import { useSessionData } from "./SessionDataProvider";
import { Outlet } from "react-router-dom";

function RequireAdmin({children}) {
    const { sessionData } = useSessionData();

    if (!sessionData.isUserAdmin) {
        return null;
    }

    return children || <Outlet />;
}

export default RequireAdmin;
